import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_hire_disabled_persons_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_hire_disabled_persons_in_line_w_legal_reqs',
  name: 'Does the facility hire disabled persons in line with legal requirements?',
  description:
    "Disability refers to physical, mental, sensory and / or intellectual impairments.\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf applicable legal standards require preferential hiring of disabled persons, answer Yes if disabled persons are hired as required (e.g., per quotas). \r\r\n\r\r\nIf legal requirements allow for alternative ways to provide for disabled persons rather than through hiring (e.g. provision to Disabled Person's Employment Security Fund) answer Yes IF the facility is meeting those requirements.\r\r\n\r\r\nIf applicable legal standards prohibit discrimination in hiring based on disability (without imposing a hiring quota), answer Yes if disabled applicants are evaluated according to their ability to perform the job (equal opportunity).\r\r\n\r\r\nAnswer No if the facility either does not hire such persons (and it is required) OR they are hired but in a way that does not meet applicable legal requirements.\r\r\n\r\r\nIf there are no applicable legal requirements in place, answer No applicable legal requirements.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-4--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5840,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
